const TZ = "America/Mexico_City";

export const fmtDate = (d) => {
  if (!d) return "—";
  const [y, m, day] = d.slice(0, 10).split("-");
  return `${day}/${m}/${y}`;
};

export const fmtSchedule = (d, t) =>
  !d && !t ? "Sin programar" : `${d ? fmtDate(d) : "Fecha sin programar"} · ${t || "Hora sin programar"}`;

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("es-MX", { timeZone: TZ, dateStyle: "short", timeStyle: "short" }) : "—";

export const todayISO = () => new Date().toLocaleDateString("en-CA", { timeZone: TZ });

export const fmtQty = (q) => (Number.isInteger(q) ? q : Number(q).toString());

export async function compressImage(file, max = 1600, quality = 0.8) {
  try {
    const bmp = await createImageBitmap(file, { imageOrientation: "from-image" });
    const scale = Math.min(1, max / Math.max(bmp.width, bmp.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bmp.width * scale);
    canvas.height = Math.round(bmp.height * scale);
    canvas.getContext("2d").drawImage(bmp, 0, 0, canvas.width, canvas.height);
    return await new Promise((res) => canvas.toBlob((b) => res(b || file), "image/jpeg", quality));
  } catch {
    return file;
  }
}
